import { ROUTE_PATH, KEYWORD_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmMetaTextAreaModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class EmailTemplateMetaModel extends FormMetaModel {
    constructor() {
        super('Add Template', ROUTE_PATH.templateGrid, ROUTE_PATH.addTemplate, 3, '', false, '', '', 'row align-items-start');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const name = new SmMetaInputModel(
            'name',
            'name',
            'input',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Template Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
           
        );

     
        const subject = new SmMetaInputModel(
            'subject',
            'subject',
            'input',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Template Subject',
            'text',
            '',
            false,
            true,
            true,

            false,
            100,
            1
        );

        const keyword = new SmMetaSelectModel(
            'keyword',
            'keyword',
            'select',
            false,
            'col-12 col-md-6',
            1,
            2,
            'Select Keyword',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            KEYWORD_OPTIONS,
            'name',
            'text',
            false,
            false,
            false,
            false,
            false,
            false
        );

        const body = new SmMetaTextAreaModel(
            'body',
            'body',
            'textarea',
            true,
            'col-12  ',
            1,
            2,
            'Template Body',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            2000,
            1
        );




        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            name,
            subject,
            keyword,
            body

        }
    }
}
